// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__jW0nc","unreadBadge":"styles_unreadBadge__1jurj","modalContent":"styles_modalContent__2hLCH","modal":"styles_modal___tWDZ"};